import { Handle, NodeProps, Position } from 'reactflow';
import { Database } from 'lucide-react';
import { PipelineNodeData } from '../../types/pipeline';

export default function DestinationNode({ data, selected }: NodeProps<PipelineNodeData>) {
  return (
    <div
      className={`rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? 'border-emerald-500 ring-2 ring-emerald-200' : 'border-emerald-200'
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-emerald-500" />
      <div className="flex items-center gap-2 text-sm font-semibold text-emerald-700">
        <Database className="h-4 w-4" />
        <span>{data.label}</span>
      </div>
      {data.description && (
        <p className="mt-1 text-xs text-slate-500">{data.description}</p>
      )}
    </div>
  );
}
